/** `member` = a person. `system` = the seeded "Lean In" official sender
 *  account: never listed, never a recipient; clients badge it as Official. */
export const ACCOUNT_KINDS = ['member', 'system'];
// Most member ids one batch profile read (POST /members/profiles) accepts. The
// web client splits a larger set into reads of this size.
export const MEMBER_PROFILES_BATCH_MAX_IDS = 100;
//# sourceMappingURL=profile.js.map